













































import mixins from 'vue-typed-mixins'
import DiaryMixin from '../../DiaryMixin'

import Reframing from './Reframing.vue'

export default mixins(DiaryMixin).extend({
  components: { Reframing },
})
